import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { SupportedLocale } from '@optiflow/types';
import { useLocale } from '@/hooks/useLocale';

/** Toggles between Arabic and English, which also flips the document direction. */
export function LanguageSwitcher() {
  const { t } = useTranslation();
  const { locale, toggleLocale } = useLocale();

  const nextLabel = locale === SupportedLocale.AR ? t('common.english') : t('common.arabic');

  return (
    <button
      type="button"
      onClick={toggleLocale}
      className="border-line text-muted hover:text-ink hover:bg-canvas inline-flex items-center gap-2 rounded-lg border bg-white px-3 py-2 text-sm"
      aria-label={`${t('common.language')}: ${nextLabel}`}
    >
      <Languages className="size-4" aria-hidden />
      <span className="hidden sm:inline">{nextLabel}</span>
    </button>
  );
}
